import { Divider, Grid, Typography } from "@mui/material";
import { TabHeader } from "./TabHeader";
import { useContext, useEffect, useMemo } from "react";
import { GameContext } from "../../provider/GameProvider";
import { BuyAutomatorButton } from "../GameButtons";
import {
  isAchievementUnlocked,
  unlockAchievement,
} from "../../types/achievements";
import { SnackbarContext } from "../../provider/SnackbarProvider";

export default function AutomatorTab({}: {}) {
  const { game, setGame } = useContext(GameContext);
  const { showSnackbar } = useContext(SnackbarContext);
  const autoBuyerUnlocked = useMemo(() => {
    return Object.keys(game.molecule.graphNodes).includes("Carbon");
  }, [game.molecule.graphNodes]);

  useEffect(() => {
    if (!isAchievementUnlocked(15, game.unlockedAchievementIds)) {
      let allAutomated = true;
      game.producers.forEach((producer, index) => {
        if (index === 0) return;
        if (!producer.automateCollect) {
          allAutomated = false;
        }
      });
      if (allAutomated) {
        unlockAchievement(15, game.unlockedAchievementIds, setGame);
        showSnackbar("Achievement unlocked!");
      }
    }
  }, [game, setGame, showSnackbar]);
  return (
    <div>
      <Grid container spacing={2}>
        <TabHeader />
        <Grid item md={12} xs={12} style={{}}>
          <Typography
            variant="h5"
            style={{
              color: "lightblue",
              textAlign: "center",
              paddingBottom: 32,
            }}
          >
            Collectors
          </Typography>
        </Grid>
        {game.producers.map((producer, index) => {
          if (index === 0) return null;
          if (!producer.alreadySeen) return null;
          return (
            <>
              <Grid item md={4} xs={4} key={index}>
                <BuyAutomatorButton index={index} type="Collector" />
              </Grid>
            </>
          );
        })}
        {autoBuyerUnlocked && (
          <>
            <Grid item xs={12} style={{ paddingTop: 48, paddingBottom: 24 }}>
              <Divider
                style={{
                  height: "1px",
                  width: "100%",
                }}
              />
            </Grid>
            <Grid item md={12} xs={12} style={{}}>
              <Typography
                variant="h5"
                style={{
                  color: "lightblue",
                  textAlign: "center",
                  paddingBottom: 32,
                }}
              >
                Auto Buyers
              </Typography>
            </Grid>
          </>
        )}
        {autoBuyerUnlocked &&
          game.producers.map((producer, index) => {
            if (index === 0) return null;
            return (
              <>
                <Grid item md={4} xs={4} key={index}>
                  <BuyAutomatorButton index={index} type="Buyer" />
                </Grid>
              </>
            );
          })}
      </Grid>
    </div>
  );
}
